import {
  $tracksTableFilters,
  $tracksTablePage,
  $tracksTablePageSize,
  $tracksTableSearch,
  $tracksTableSort,
  type TracksSortState,
  trackMultipleDelete,
  tracksTableFiltersInit,
  tracksTableQuery,
  tracksTableSearchReset,
} from '@/entities/tracks'
import { type GetApiTracksQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { combine, createEvent, createStore, sample } from 'effector'
import { createGate } from 'effector-react'

import {
  DEFAULT_TRACKS_LIST_PAGE_TAB,
  type TracksListPageTabsKeys,
  TracksListPageTabsKeysTypesEnum,
} from '../lib/tabs'

// Gate
export const TracksListPageGate = createGate()

// Altering
const $filterTypes = $tracksTableFilters.map((filters) => filters.Types || null)

sample({
  source: combine({
    queryStatus: tracksTableQuery.$status,
    gateStatus: TracksListPageGate.status,
  }),
  clock: $filterTypes,
  filter: ({ queryStatus, gateStatus }) =>
    queryStatus !== 'initial' && gateStatus,
  target: [tracksTableSearchReset],
})

// Tab
export const tracksListPageTabChanged = createEvent<TracksListPageTabsKeys>()
export const $tracksListPageTab = createStore<TracksListPageTabsKeys>(
  DEFAULT_TRACKS_LIST_PAGE_TAB,
).on(tracksListPageTabChanged, (_, payload) => payload)

sample({
  clock: $tracksListPageTab,
  fn: (tab) => ({
    Types: [TracksListPageTabsKeysTypesEnum[tab]],
  }),
  target: tracksTableFiltersInit,
})

// Last state

// Filters
export const $tracksListPageLatestFilters =
  createStore<GetApiTracksQueryParams>({
    Types: [TracksListPageTabsKeysTypesEnum[DEFAULT_TRACKS_LIST_PAGE_TAB]],
  }).on($tracksListPageTab, (filters, tab) => ({
    ...filters,
    Types: [TracksListPageTabsKeysTypesEnum[tab]],
  }))

sample({
  source: $tracksTableFilters,
  clock: TracksListPageGate.close,
  target: $tracksListPageLatestFilters,
})
// Sort
export const $tracksListPageLatestSort = createStore<TracksSortState>({
  field: null,
  order: null,
})
sample({
  source: $tracksTableSort,
  clock: TracksListPageGate.close,
  target: $tracksListPageLatestSort,
})

// Page
export const $tracksListPageLatestPage = createStore<number>(
  DEFAULT_PAGE,
).reset([trackMultipleDelete.finished.finally])
sample({
  source: $tracksTablePage,
  clock: TracksListPageGate.close,
  target: $tracksListPageLatestPage,
})
// Page size
export const $tracksListPageLatestPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  clock: TracksListPageGate.close,
  source: $tracksTablePageSize,
  target: $tracksListPageLatestPageSize,
})
// Search
export const $tracksListPageLatestSearch = createStore<string>('')
sample({
  clock: TracksListPageGate.close,
  source: $tracksTableSearch,
  fn: (search) => search || '',
  target: $tracksListPageLatestSearch,
})
